<template>
  <div class="container">
    <h1 class="page-header">Kontaktpersoner (steg 1 av 3)</h1>
    <form class="reg-form" @submit.prevent="onSubmit">
      <div class="row reg-form__wrapper py-3 rounded">
        <div>
          <h2 class="h4">Du som är inloggad</h2>
          <p>Du som är inloggad och bekräftar avtalen kommer att stå som undertecknare. </p>
          <p>I avtalet behöver det även finnas en kontaktperson för administration av PUB-avtalet samt en kontaktperson
            för frågor om dataskydd. Du kan välja att själv vara kontaktperson eller så kan du ange andra personer. </p>
        </div>
        <div>
          <h2 class="h4">Ange kontaktperson PUB-avtal</h2>
          <div class="form-group">
            <label for="first-name-assistant">Förnamn</label>
            <input id="first-name-assistant" v-model="form.contactInfos[0].firstName" aria-required="true"
                   class="form-control"
                   required type="text" />
          </div>
          <div class="form-group">
            <label for="last-name-assistant">Efternamn</label>
            <input id="last-name-assistant" v-model="form.contactInfos[0].lastName" aria-required="true"
                   class="form-control"
                   required type="text" />
          </div>
          <div class="form-group">
            <label for="email-assistant">E-post</label>
            <input id="email-assistant" v-model="form.contactInfos[0].email"
                   aria-errormessage="validation-error-assistant-email"
                   aria-required="true" class="form-control"
                   required type="email" />
            <div v-if="!state.assistantEmailValid" id="validation-error-assistant-email"
                 class="d-flex rounded mt-2 p-2 invalid-input">
              Felaktigt format på e-post
            </div>
          </div>
          <div class="form-group">
            <label for="phone-assistant">Telefon</label>
            <input id="phone-assistant" v-model="form.contactInfos[0].phone" aria-required="true"
                   class="form-control" required type="tel" />
          </div>
        </div>
        <div>
          <h2 class="h4">Ange kontaktperson dataskydd</h2>
          <div class="form-group">
            <label for="firstName">Förnamn</label>
            <input id="firstName" v-model="form.contactInfos[1].firstName" aria-required="true"
                   class="form-control"
                   required type="text" />
          </div>
          <div class="form-group">
            <label for="lastName">Efternamn</label>
            <input id="lastName" v-model="form.contactInfos[1].lastName" aria-required="true"
                   class="form-control"
                   required type="text" />
          </div>
          <div class="form-group">
            <label for="email">E-post</label>
            <input id="email" v-model="form.contactInfos[1].email"
                   aria-errormessage="validation-error-data-email-valid" aria-required="true"
                   class="form-control" required type="email" />
            <div v-if="!state.dataEmailValid" id="validation-error-data-email-valid"
                 class="d-flex rounded mt-2 p-2 invalid-input">
              Felaktigt format på e-post
            </div>
          </div>
          <div class="form-group">
            <label for="phone">Telefon</label>
            <input id="phone" v-model="form.contactInfos[1].phone" aria-required="true" class="form-control" required type="tel" />
          </div>
        </div>
      </div>
      <CtaPanel>
        <div class="buttons-container push-buttons-right">
          <PreviousNavLink :go-to-link="`/organisation/${orgId}`"
                           previous-label="Avbryt"></PreviousNavLink>
          <button class="btn btn-light" type="submit">Nästa steg &nbsp;&nbsp;<span
            class="fas fa-chevron-right"></span></button>
        </div>
      </CtaPanel>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "@vue/runtime-core";
import CtaPanel from "../components/CtaPanel.vue";
import PDFView from "../components/PDFView.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { useRoute, useRouter } from "vue-router";
import { ContactInfoModel } from "@Shared/Models/ContactInfoModel";
import { useUserStore } from "@/stores/user";
import { emailRegex } from "@/lib/validators";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

export default defineComponent({
  name: "OrgAgreementContacts",
  components: {
    CtaPanel,
    PDFView,
    PreviousNavLink
  },
  setup() {
    const route = useRoute();
    const { orgId } = route.params;
    const router = useRouter();
    const state = reactive({
      agreementPath: "",
      pubAgreementPath: "",
      assistantEmailValid: true,
      dataEmailValid: true
    });
    const organisationStore = useOrganisationStore();
    const userStore = useUserStore();
    const user = userStore.user;

    interface contacts {
      contactInfos: ContactInfoModel[];
    }

    const form = ref<contacts>({
      contactInfos: [
        {
          id: 0,
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          infoType: "Assistant",
          info: ""
        },
        {
          id: 0,
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          infoType: "Data",
          info: ""
        }
      ]
    });

    function mapExistingContactInfo(contactInfo: ContactInfoModel, infoType) {
      return {
        id: contactInfo.id,
        firstName: contactInfo.firstName,
        infoType: infoType,
        email: contactInfo.email,
        info: contactInfo.info,
        phone: contactInfo.phone,
        lastName: contactInfo.lastName

      };
    }

    const setContactInfos = async (orgId) => {
      await organisationStore.GetContactInfosFromApi(orgId);

      const assistant = organisationStore.getContactInfoByInfoType("Assistant");
      if (assistant) {
        form.value.contactInfos[0] = reactive({ ...assistant });
      } else {
        form.value.contactInfos[0] = mapExistingContactInfo(user, "Assistant");
      }
      const dataProtection = organisationStore.getContactInfoByInfoType("Data");
      if (dataProtection) {
        form.value.contactInfos[1] = reactive({ ...dataProtection });
      } else {
        console.log(user);
        form.value.contactInfos[1] = mapExistingContactInfo(user, "Data");

      }
    };

    setContactInfos(orgId);

    const onSubmit = async () => {
      state.assistantEmailValid = emailRegex.test(
        form.value.contactInfos[0].email
      );

      state.dataEmailValid = emailRegex.test(
        form.value.contactInfos[1].email
      );

      if (!state.assistantEmailValid || !state.dataEmailValid) {
        return;
      }

      //  If contact already exists, omit id property to not create a new contact, backend then updates the existing user
      const contactInfos = organisationStore.getContactInfos();
      form.value.contactInfos.forEach(ci => {
        let found = false;
        if (contactInfos.find(x => x.email === ci.email && x.infoType !== "Head" && x.infoType === ci.infoType)) {
          found = true;
        }
        if (!found) {
          delete ci.id;
        }
      });
      const result = await organisationStore.SaveContactInfos(orgId as string, form.value.contactInfos);
      if (result) {
        await router.push(`/organisation/${orgId}/avtal/bekrafta/1`);
      }
    };
    return {
      state,
      orgId,
      form,
      onSubmit
    };
  }
});
</script>

<style lang="scss" scoped>
.reg-form__wrapper {
  padding: 16px;
  display: flex;
  gap: 62px;

  & > * {
    flex: 1;
  }

  background-color: rgba(230, 238, 247, 0.5);
}

.buttons-container {
  margin-top: 24px;
}

.invalid-input {
  background-color: var(--spsm-red-5);
}
</style>